import { render, staticRenderFns } from "./Reflexologie.vue?vue&type=template&id=2e241742&"
import script from "./Reflexologie.vue?vue&type=script&lang=js&"
export * from "./Reflexologie.vue?vue&type=script&lang=js&"
import style0 from "./Reflexologie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports